module.exports = __webpack_public_path__ + "static/media/business.1b625592.svg";